import React from 'react';
import { Row, Col, Image} from 'react-bootstrap';
import '../styles/gallery.scss';

export default function  Gallery({listOfImages}){
    return (
        <div>
        {
            listOfImages.map(
              (image, index) =>  
              <Row className = "text-center">
                {image[0] &&
                  <Col md={{ span: 4 }}>
                    <Image key={index * 3} src={image[0]} alt="info" className='galleryImage mb-4'/>
                  </Col>
                }
                {image[1] &&
                  <Col md={{ span: 4 }}>
                    <img key={index * 3 + 1} src={image[1]} alt="info" className='galleryImage mb-4'/>
                  </Col>
                }
                {image[2] &&
                  <Col md={{ span: 4 }}>
                    <img key={index * 3 + 2} src={image[2]} alt="info" className='galleryImage mb-4'/>
                  </Col>
                }
              </Row>
            )
        }
        </div>
    )
}